import React from 'react';
import {
  Card,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Table,
  Paper,
  Typography,
} from '@material-ui/core';

import { useAppSelector } from 'hooks/reduxTypedHooks';

import useStyles from './FaqStyle';

const BankRequisites = () => {
  const classes = useStyles();
  const { providerProfileInfo } = useAppSelector((state) => state.users);
  const { accounts } = providerProfileInfo;

  return (
    <Card className={classes.card}>
      <Typography variant="overline">Банковские реквизиты</Typography>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell>Расчетный счет </TableCell>
              <TableCell>
                {accounts ? accounts[0]['account'] : 'Не указан'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Наименование банка</TableCell>
              <TableCell>
                {accounts ? accounts[0]['name'] : 'Не указано'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>БИК банка</TableCell>
              <TableCell>
                {accounts ? accounts[0]['bik'] : 'Не указан'}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Назначение платежа</TableCell>
              <TableCell>
                {accounts ? accounts[0]['naznachenie'] : 'Не указано'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Код назначения платежа</TableCell>
              <TableCell>
                {accounts ? accounts[0]['codePay'] : 'Не указан'}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default BankRequisites;
